import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hero-1.jpg'


const _withScopeId = n => (_pushScopeId("data-v-0e8da117"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "hero__content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "lead" }
const _hoisted_6 = { class: "hero__actions" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Start a project ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Join our team ")
const _hoisted_9 = {
  key: 0,
  class: "hero__image"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", {
          class: "hero__title text-white",
          innerHTML: _ctx.titlePipe(_ctx.page?.title)
        }, null, 8, _hoisted_4),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.page?.lead), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/contact-us",
            class: "btn btn--primary"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/join-us",
            class: "btn btn--outline btn--outline--white"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_ctx.page?.thumb)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
      : _createCommentVNode("", true)
  ]))
}